import { ReactNode } from 'react';

interface CoverProps {
  children: ReactNode;
  center?: boolean;
}

export function Cover({ children, center = false }: CoverProps) {
  return (
    <div className={`component-cover ${center ? 'center' : ''}`}>
      {children}
    </div>
  );
}
